:host {
  --color: currentColor;

  display: contents;
  color: var(--color);
}

iconify-icon {
  color: inherit;
}
